// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.4
// source: bridge/models/epoch.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { ChainType, chainTypeFromJSON, chainTypeToJSON } from "./chain";
import { Party } from "./party";

export const protobufPackage = "core.bridge";

export enum EpochStatus {
  INITIATED = 0,
  MIGRATION_FINALIZING = 1,
  RUNNING = 2,
  SHUTDOWN = 3,
  UNSUPPORTED = 4,
  UNRECOGNIZED = -1,
}

export function epochStatusFromJSON(object: any): EpochStatus {
  switch (object) {
    case 0:
    case "INITIATED":
      return EpochStatus.INITIATED;
    case 1:
    case "MIGRATION_FINALIZING":
      return EpochStatus.MIGRATION_FINALIZING;
    case 2:
    case "RUNNING":
      return EpochStatus.RUNNING;
    case 3:
    case "SHUTDOWN":
      return EpochStatus.SHUTDOWN;
    case 4:
    case "UNSUPPORTED":
      return EpochStatus.UNSUPPORTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return EpochStatus.UNRECOGNIZED;
  }
}

export function epochStatusToJSON(object: EpochStatus): string {
  switch (object) {
    case EpochStatus.INITIATED:
      return "INITIATED";
    case EpochStatus.MIGRATION_FINALIZING:
      return "MIGRATION_FINALIZING";
    case EpochStatus.RUNNING:
      return "RUNNING";
    case EpochStatus.SHUTDOWN:
      return "SHUTDOWN";
    case EpochStatus.UNSUPPORTED:
      return "UNSUPPORTED";
    case EpochStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum EpochSignatureMod {
  UNSPECIFIED_MOD = 0,
  ADD = 1,
  REMOVE = 2,
  UNRECOGNIZED = -1,
}

export function epochSignatureModFromJSON(object: any): EpochSignatureMod {
  switch (object) {
    case 0:
    case "UNSPECIFIED_MOD":
      return EpochSignatureMod.UNSPECIFIED_MOD;
    case 1:
    case "ADD":
      return EpochSignatureMod.ADD;
    case 2:
    case "REMOVE":
      return EpochSignatureMod.REMOVE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return EpochSignatureMod.UNRECOGNIZED;
  }
}

export function epochSignatureModToJSON(object: EpochSignatureMod): string {
  switch (object) {
    case EpochSignatureMod.UNSPECIFIED_MOD:
      return "UNSPECIFIED_MOD";
    case EpochSignatureMod.ADD:
      return "ADD";
    case EpochSignatureMod.REMOVE:
      return "REMOVE";
    case EpochSignatureMod.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Epoch {
  id: number;
  status: EpochStatus;
  startBlock: string;
  endBlock: string;
  /** store copy of params here, we do not link to params to avoid issues with params changing over time */
  parties: Party[];
  tssThreshold: number;
  tssInfo: TSSInfo[];
  finalizedBlock: string;
}

export interface EpochSignature {
  /** remove or add a signature */
  mod: EpochSignatureMod;
  epochId: number;
  signature: string;
  data?: EpochSignatureData | undefined;
}

export interface EpochSignatureData {
  /** address or pub key */
  newSigner: string;
  startTime: string;
  endTime: string;
  /** is used to prevent replay attacks on EVM chains */
  nonce: string;
}

export interface EpochChainSignatures {
  epochId: number;
  chainType: ChainType;
  addedSignature?: EpochSignature | undefined;
  removedSignature?: EpochSignature | undefined;
}

export interface EpochBridgeAddress {
  epochId: number;
  chainId: string;
  address: string;
}

export interface EpochSubmissions {
  epochId: number;
  submissions: number;
}

export interface TSSInfo {
  certificate: string;
  domain: string;
  address: string;
  /** if is not active it should be removed from signers in this epoch */
  active: boolean;
}

function createBaseEpoch(): Epoch {
  return {
    id: 0,
    status: 0,
    startBlock: "0",
    endBlock: "0",
    parties: [],
    tssThreshold: 0,
    tssInfo: [],
    finalizedBlock: "0",
  };
}

export const Epoch: MessageFns<Epoch> = {
  encode(message: Epoch, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.status !== 0) {
      writer.uint32(16).int32(message.status);
    }
    if (message.startBlock !== "0") {
      writer.uint32(24).uint64(message.startBlock);
    }
    if (message.endBlock !== "0") {
      writer.uint32(32).uint64(message.endBlock);
    }
    for (const v of message.parties) {
      Party.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.tssThreshold !== 0) {
      writer.uint32(48).uint32(message.tssThreshold);
    }
    for (const v of message.tssInfo) {
      TSSInfo.encode(v!, writer.uint32(58).fork()).join();
    }
    if (message.finalizedBlock !== "0") {
      writer.uint32(64).uint64(message.finalizedBlock);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Epoch {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEpoch();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.startBlock = reader.uint64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.endBlock = reader.uint64().toString();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.parties.push(Party.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.tssThreshold = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.tssInfo.push(TSSInfo.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.finalizedBlock = reader.uint64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Epoch {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      status: isSet(object.status) ? epochStatusFromJSON(object.status) : 0,
      startBlock: isSet(object.startBlock)
        ? globalThis.String(object.startBlock)
        : isSet(object.start_block)
        ? globalThis.String(object.start_block)
        : "0",
      endBlock: isSet(object.endBlock)
        ? globalThis.String(object.endBlock)
        : isSet(object.end_block)
        ? globalThis.String(object.end_block)
        : "0",
      parties: globalThis.Array.isArray(object?.parties) ? object.parties.map((e: any) => Party.fromJSON(e)) : [],
      tssThreshold: isSet(object.tssThreshold)
        ? globalThis.Number(object.tssThreshold)
        : isSet(object.tss_threshold)
        ? globalThis.Number(object.tss_threshold)
        : 0,
      tssInfo: globalThis.Array.isArray(object?.tssInfo)
        ? object.tssInfo.map((e: any) => TSSInfo.fromJSON(e))
        : globalThis.Array.isArray(object?.tss_info)
        ? object.tss_info.map((e: any) => TSSInfo.fromJSON(e))
        : [],
      finalizedBlock: isSet(object.finalizedBlock)
        ? globalThis.String(object.finalizedBlock)
        : isSet(object.finalized_block)
        ? globalThis.String(object.finalized_block)
        : "0",
    };
  },

  toJSON(message: Epoch): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.status !== 0) {
      obj.status = epochStatusToJSON(message.status);
    }
    if (message.startBlock !== "0") {
      obj.startBlock = message.startBlock;
    }
    if (message.endBlock !== "0") {
      obj.endBlock = message.endBlock;
    }
    if (message.parties?.length) {
      obj.parties = message.parties.map((e) => Party.toJSON(e));
    }
    if (message.tssThreshold !== 0) {
      obj.tssThreshold = Math.round(message.tssThreshold);
    }
    if (message.tssInfo?.length) {
      obj.tssInfo = message.tssInfo.map((e) => TSSInfo.toJSON(e));
    }
    if (message.finalizedBlock !== "0") {
      obj.finalizedBlock = message.finalizedBlock;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Epoch>, I>>(base?: I): Epoch {
    return Epoch.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Epoch>, I>>(object: I): Epoch {
    const message = createBaseEpoch();
    message.id = object.id ?? 0;
    message.status = object.status ?? 0;
    message.startBlock = object.startBlock ?? "0";
    message.endBlock = object.endBlock ?? "0";
    message.parties = object.parties?.map((e) => Party.fromPartial(e)) || [];
    message.tssThreshold = object.tssThreshold ?? 0;
    message.tssInfo = object.tssInfo?.map((e) => TSSInfo.fromPartial(e)) || [];
    message.finalizedBlock = object.finalizedBlock ?? "0";
    return message;
  },
};

function createBaseEpochSignature(): EpochSignature {
  return { mod: 0, epochId: 0, signature: "", data: undefined };
}

export const EpochSignature: MessageFns<EpochSignature> = {
  encode(message: EpochSignature, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mod !== 0) {
      writer.uint32(8).int32(message.mod);
    }
    if (message.epochId !== 0) {
      writer.uint32(16).uint32(message.epochId);
    }
    if (message.signature !== "") {
      writer.uint32(26).string(message.signature);
    }
    if (message.data !== undefined) {
      EpochSignatureData.encode(message.data, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EpochSignature {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEpochSignature();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.mod = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.epochId = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.signature = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.data = EpochSignatureData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EpochSignature {
    return {
      mod: isSet(object.mod) ? epochSignatureModFromJSON(object.mod) : 0,
      epochId: isSet(object.epochId)
        ? globalThis.Number(object.epochId)
        : isSet(object.epoch_id)
        ? globalThis.Number(object.epoch_id)
        : 0,
      signature: isSet(object.signature) ? globalThis.String(object.signature) : "",
      data: isSet(object.data) ? EpochSignatureData.fromJSON(object.data) : undefined,
    };
  },

  toJSON(message: EpochSignature): unknown {
    const obj: any = {};
    if (message.mod !== 0) {
      obj.mod = epochSignatureModToJSON(message.mod);
    }
    if (message.epochId !== 0) {
      obj.epochId = Math.round(message.epochId);
    }
    if (message.signature !== "") {
      obj.signature = message.signature;
    }
    if (message.data !== undefined) {
      obj.data = EpochSignatureData.toJSON(message.data);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EpochSignature>, I>>(base?: I): EpochSignature {
    return EpochSignature.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EpochSignature>, I>>(object: I): EpochSignature {
    const message = createBaseEpochSignature();
    message.mod = object.mod ?? 0;
    message.epochId = object.epochId ?? 0;
    message.signature = object.signature ?? "";
    message.data = (object.data !== undefined && object.data !== null)
      ? EpochSignatureData.fromPartial(object.data)
      : undefined;
    return message;
  },
};

function createBaseEpochSignatureData(): EpochSignatureData {
  return { newSigner: "", startTime: "0", endTime: "0", nonce: "" };
}

export const EpochSignatureData: MessageFns<EpochSignatureData> = {
  encode(message: EpochSignatureData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.newSigner !== "") {
      writer.uint32(10).string(message.newSigner);
    }
    if (message.startTime !== "0") {
      writer.uint32(16).uint64(message.startTime);
    }
    if (message.endTime !== "0") {
      writer.uint32(24).uint64(message.endTime);
    }
    if (message.nonce !== "") {
      writer.uint32(34).string(message.nonce);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EpochSignatureData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEpochSignatureData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.newSigner = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.startTime = reader.uint64().toString();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.endTime = reader.uint64().toString();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.nonce = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EpochSignatureData {
    return {
      newSigner: isSet(object.newSigner)
        ? globalThis.String(object.newSigner)
        : isSet(object.new_signer)
        ? globalThis.String(object.new_signer)
        : "",
      startTime: isSet(object.startTime)
        ? globalThis.String(object.startTime)
        : isSet(object.start_time)
        ? globalThis.String(object.start_time)
        : "0",
      endTime: isSet(object.endTime)
        ? globalThis.String(object.endTime)
        : isSet(object.end_time)
        ? globalThis.String(object.end_time)
        : "0",
      nonce: isSet(object.nonce) ? globalThis.String(object.nonce) : "",
    };
  },

  toJSON(message: EpochSignatureData): unknown {
    const obj: any = {};
    if (message.newSigner !== "") {
      obj.newSigner = message.newSigner;
    }
    if (message.startTime !== "0") {
      obj.startTime = message.startTime;
    }
    if (message.endTime !== "0") {
      obj.endTime = message.endTime;
    }
    if (message.nonce !== "") {
      obj.nonce = message.nonce;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EpochSignatureData>, I>>(base?: I): EpochSignatureData {
    return EpochSignatureData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EpochSignatureData>, I>>(object: I): EpochSignatureData {
    const message = createBaseEpochSignatureData();
    message.newSigner = object.newSigner ?? "";
    message.startTime = object.startTime ?? "0";
    message.endTime = object.endTime ?? "0";
    message.nonce = object.nonce ?? "";
    return message;
  },
};

function createBaseEpochChainSignatures(): EpochChainSignatures {
  return { epochId: 0, chainType: 0, addedSignature: undefined, removedSignature: undefined };
}

export const EpochChainSignatures: MessageFns<EpochChainSignatures> = {
  encode(message: EpochChainSignatures, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.epochId !== 0) {
      writer.uint32(8).uint32(message.epochId);
    }
    if (message.chainType !== 0) {
      writer.uint32(16).int32(message.chainType);
    }
    if (message.addedSignature !== undefined) {
      EpochSignature.encode(message.addedSignature, writer.uint32(26).fork()).join();
    }
    if (message.removedSignature !== undefined) {
      EpochSignature.encode(message.removedSignature, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EpochChainSignatures {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEpochChainSignatures();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.epochId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.chainType = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.addedSignature = EpochSignature.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.removedSignature = EpochSignature.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EpochChainSignatures {
    return {
      epochId: isSet(object.epochId)
        ? globalThis.Number(object.epochId)
        : isSet(object.epoch_id)
        ? globalThis.Number(object.epoch_id)
        : 0,
      chainType: isSet(object.chainType)
        ? chainTypeFromJSON(object.chainType)
        : isSet(object.chain_type)
        ? chainTypeFromJSON(object.chain_type)
        : 0,
      addedSignature: isSet(object.addedSignature)
        ? EpochSignature.fromJSON(object.addedSignature)
        : isSet(object.added_signature)
        ? EpochSignature.fromJSON(object.added_signature)
        : undefined,
      removedSignature: isSet(object.removedSignature)
        ? EpochSignature.fromJSON(object.removedSignature)
        : isSet(object.removed_signature)
        ? EpochSignature.fromJSON(object.removed_signature)
        : undefined,
    };
  },

  toJSON(message: EpochChainSignatures): unknown {
    const obj: any = {};
    if (message.epochId !== 0) {
      obj.epochId = Math.round(message.epochId);
    }
    if (message.chainType !== 0) {
      obj.chainType = chainTypeToJSON(message.chainType);
    }
    if (message.addedSignature !== undefined) {
      obj.addedSignature = EpochSignature.toJSON(message.addedSignature);
    }
    if (message.removedSignature !== undefined) {
      obj.removedSignature = EpochSignature.toJSON(message.removedSignature);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EpochChainSignatures>, I>>(base?: I): EpochChainSignatures {
    return EpochChainSignatures.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EpochChainSignatures>, I>>(object: I): EpochChainSignatures {
    const message = createBaseEpochChainSignatures();
    message.epochId = object.epochId ?? 0;
    message.chainType = object.chainType ?? 0;
    message.addedSignature = (object.addedSignature !== undefined && object.addedSignature !== null)
      ? EpochSignature.fromPartial(object.addedSignature)
      : undefined;
    message.removedSignature = (object.removedSignature !== undefined && object.removedSignature !== null)
      ? EpochSignature.fromPartial(object.removedSignature)
      : undefined;
    return message;
  },
};

function createBaseEpochBridgeAddress(): EpochBridgeAddress {
  return { epochId: 0, chainId: "", address: "" };
}

export const EpochBridgeAddress: MessageFns<EpochBridgeAddress> = {
  encode(message: EpochBridgeAddress, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.epochId !== 0) {
      writer.uint32(8).uint32(message.epochId);
    }
    if (message.chainId !== "") {
      writer.uint32(18).string(message.chainId);
    }
    if (message.address !== "") {
      writer.uint32(26).string(message.address);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EpochBridgeAddress {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEpochBridgeAddress();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.epochId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.chainId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.address = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EpochBridgeAddress {
    return {
      epochId: isSet(object.epochId)
        ? globalThis.Number(object.epochId)
        : isSet(object.epoch_id)
        ? globalThis.Number(object.epoch_id)
        : 0,
      chainId: isSet(object.chainId)
        ? globalThis.String(object.chainId)
        : isSet(object.chain_id)
        ? globalThis.String(object.chain_id)
        : "",
      address: isSet(object.address) ? globalThis.String(object.address) : "",
    };
  },

  toJSON(message: EpochBridgeAddress): unknown {
    const obj: any = {};
    if (message.epochId !== 0) {
      obj.epochId = Math.round(message.epochId);
    }
    if (message.chainId !== "") {
      obj.chainId = message.chainId;
    }
    if (message.address !== "") {
      obj.address = message.address;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EpochBridgeAddress>, I>>(base?: I): EpochBridgeAddress {
    return EpochBridgeAddress.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EpochBridgeAddress>, I>>(object: I): EpochBridgeAddress {
    const message = createBaseEpochBridgeAddress();
    message.epochId = object.epochId ?? 0;
    message.chainId = object.chainId ?? "";
    message.address = object.address ?? "";
    return message;
  },
};

function createBaseEpochSubmissions(): EpochSubmissions {
  return { epochId: 0, submissions: 0 };
}

export const EpochSubmissions: MessageFns<EpochSubmissions> = {
  encode(message: EpochSubmissions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.epochId !== 0) {
      writer.uint32(8).uint32(message.epochId);
    }
    if (message.submissions !== 0) {
      writer.uint32(16).uint32(message.submissions);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EpochSubmissions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEpochSubmissions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.epochId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.submissions = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EpochSubmissions {
    return {
      epochId: isSet(object.epochId)
        ? globalThis.Number(object.epochId)
        : isSet(object.epoch_id)
        ? globalThis.Number(object.epoch_id)
        : 0,
      submissions: isSet(object.submissions) ? globalThis.Number(object.submissions) : 0,
    };
  },

  toJSON(message: EpochSubmissions): unknown {
    const obj: any = {};
    if (message.epochId !== 0) {
      obj.epochId = Math.round(message.epochId);
    }
    if (message.submissions !== 0) {
      obj.submissions = Math.round(message.submissions);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EpochSubmissions>, I>>(base?: I): EpochSubmissions {
    return EpochSubmissions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EpochSubmissions>, I>>(object: I): EpochSubmissions {
    const message = createBaseEpochSubmissions();
    message.epochId = object.epochId ?? 0;
    message.submissions = object.submissions ?? 0;
    return message;
  },
};

function createBaseTSSInfo(): TSSInfo {
  return { certificate: "", domain: "", address: "", active: false };
}

export const TSSInfo: MessageFns<TSSInfo> = {
  encode(message: TSSInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.certificate !== "") {
      writer.uint32(10).string(message.certificate);
    }
    if (message.domain !== "") {
      writer.uint32(18).string(message.domain);
    }
    if (message.address !== "") {
      writer.uint32(26).string(message.address);
    }
    if (message.active !== false) {
      writer.uint32(32).bool(message.active);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TSSInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTSSInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.certificate = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.domain = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.address = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.active = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TSSInfo {
    return {
      certificate: isSet(object.certificate) ? globalThis.String(object.certificate) : "",
      domain: isSet(object.domain) ? globalThis.String(object.domain) : "",
      address: isSet(object.address) ? globalThis.String(object.address) : "",
      active: isSet(object.active) ? globalThis.Boolean(object.active) : false,
    };
  },

  toJSON(message: TSSInfo): unknown {
    const obj: any = {};
    if (message.certificate !== "") {
      obj.certificate = message.certificate;
    }
    if (message.domain !== "") {
      obj.domain = message.domain;
    }
    if (message.address !== "") {
      obj.address = message.address;
    }
    if (message.active !== false) {
      obj.active = message.active;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TSSInfo>, I>>(base?: I): TSSInfo {
    return TSSInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TSSInfo>, I>>(object: I): TSSInfo {
    const message = createBaseTSSInfo();
    message.certificate = object.certificate ?? "";
    message.domain = object.domain ?? "";
    message.address = object.address ?? "";
    message.active = object.active ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
